module.exports = __webpack_public_path__ + "img/icon_3_39.6f30aa38.png";